import { CarouselProvider, Slider, Slide, ButtonBack, ButtonNext, Dot } from 'pure-react-carousel'
import 'pure-react-carousel/dist/react-carousel.es.css';
import { ChevronLeftIcon, ChevronRightIcon } from '@chakra-ui/icons'
import { Box, Icon, Image } from '@chakra-ui/react';
import placeholder from '../multimedia/placeholder.jpg'

const CustomRightArrow = () => (
    <Box display="flex" alignItems="center" bg="easycar1.500" h="full" cursor="pointer">
        <Icon as={ChevronRightIcon} color="white" boxSize={8} />
    </Box>
)

const CustomLeftArrow = () => (
    <Box display="flex" alignItems="center" bg="easycar1.500" h="full" cursor="pointer">
        <Icon as={ChevronLeftIcon} color="white" boxSize={8} />
    </Box>
)

const CarPreview = ({ car }) => {
    const images = [
        { image: car.urlFotoDelantera },
        { image: car.urlFotoLateral },
        { image: car.urlFotoTrasera },
        { image: car.urlFotoMotor },
        { image: car.urlFotoKilometraje }
    ]

    const replaceImage = (error) => {
        error.target.src = placeholder;
    }

    return (
        <Box w="full">
            <CarouselProvider
                naturalSlideWidth={750}
                naturalSlideHeight={500}
                totalSlides={images.length}
                infinite
            >
                <Slider>
                    {images.map((image, i) => (
                        <Slide key={i} index={i}>
                            <Box
                                position="relative"
                                display="flex"
                                alignItems="center"
                                justifyContent="center"
                                h="500px"
                                w="full"
                                bg="gray.200"
                            >
                                <Image
                                    objectFit="contain"
                                    h="100%"
                                    w="auto"
                                    alt={`car-${i}`}
                                    src={image.image}
                                    onError={replaceImage}
                                    zIndex={1}
                                />
                            </Box>
                        </Slide>
                    ))}
                </Slider>

                {/* Controles y miniaturas */}
                <Box
                    w="full"
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    gap="5px"
                    mt="10px"
                >
                    <ButtonBack><CustomLeftArrow /></ButtonBack>
                    {images.map((image, i) => (
                        <Dot key={i} slide={i}>
                            <Image
                                objectFit="cover"
                                w="120px"
                                h="80px"
                                alt={`thumb-${i}`}
                                src={image.image}
                                borderRadius="5px"
                                onError={replaceImage}
                            />
                        </Dot>
                    ))}
                    <ButtonNext><CustomRightArrow /></ButtonNext>
                </Box>
            </CarouselProvider>
        </Box>
    )
}

export default CarPreview
